<style lang="scss">
@import '~scss/_variables';

.results-heading {
    margin-top: $grid-size;
    position: relative;

    font-family: $font-family-2;
    font-size: 185px;
    color: $color-white;

    .emissions-count {
        display: block;
        text-align: left;
        line-height: 0.53;
        white-space: nowrap;
    }

    .bottom {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: $grid-size;
        font-size: 0.55em;
        line-height: 1.05;

        sub {
            font-size: 0.6em;
            bottom: 0;
        }
    }

        .left {
            display: flex;
            align-items: flex-start;
        }

            .separator {
                margin: 0.44em 0.24em 0 0.5em;
                font-size: 0.6em;
            }

            .subject {
                margin-top: 0.62em;
                font-size: 0.6em;
                text-align: left;
                line-height: 1;
                color: $color-text-2;
            }

                .units-switch {
                    margin-top: 14px;
                    margin-left: 4px;
                }

        .right {
            text-align: right;

            .element {
                display: block;
                margin-top: -0.14em;
                font-size: 0.6em;
            }
        }

    @include media-smaller('lg') {
        font-size: 124px;
    }

    @include media-smaller('md') {
        font-size: 61px;

        .bottom {
            display: block;
            margin-top: 0;
        }

            .left {
                margin-top: 17px;
            }

            .right {
                margin-top: 30px;
                font-size: 1.82em;
                text-align: left;

                .element {
                    margin-top: 0;
                    font-size: 0.55em;
                }
            }

        br {
            display: none;
        }

        .units-switch {
            margin-top: 10px;
            margin-left: -4px;
        }
    }
}

#route {
    margin-top: 137px;

    .places {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 18px;
        color: $color-white;
    }

        .left,
        .right {
            flex: 1 1 0;
        }

            .place {
                margin-bottom: 0;
                font-family: $font-family-2;
                font-size: 64px;
                font-weight: bold;
                line-height: 1;
            }

            .description {
                margin-bottom: 0;
                font-size: 22px;
                line-height: 1.3;
            }

        .left {
            text-align: left;
        }

        .points {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            margin-top: 0.64em;

            font-size: 28px;
            color: $color-black;
        }

            .point {
                margin: 0 20px;
                font-family: $font-family-2;
                font-weight: bold;
            }

            .icon {
                display: flex;
                font-size: 32px;
                position: relative;
                    top: 0.02em;
            }

        .right {
            text-align: right;
        }

    .places-separator {
        $places-separator-border: 2px;

        width: 100%;
        height: 32px;
        margin-top: 11px;
        position: relative;
        border: $places-separator-border solid $color-black;
        border-top: none;

        &:after {
            content: '';
            width: $places-separator-border;
            height: 100%;
            padding-bottom: #{15px + $places-separator-border};
            box-sizing: content-box;
            position: absolute;
                bottom: -#{15px + $places-separator-border};
                left: 50%;

            transform: translate(-50%, 0);
            background: $color-black;
        }
    }

    .route-stats {
        margin-top: 33px;
        font-size: 18px;
        font-family: $font-family-2;

        .distance {
            margin-bottom: 0;
            font-size: 2em;
            font-weight: bold;
            line-height: 0.9;
            color: $color-white;

            i {
                font-style: normal;
                font-weight: $font-weight-2-regular;
            }
        }

        .time {
            color: $color-accent-1-darker;
        }
    }

    @include media-smaller('lg') {
        .place {
            font-size: 32px;
        }

        .description {
            font-size: 16px;
        }

        .points {
            margin-top: 0;
            font-size: 24px;
        }

        .places-separator {
            margin-top: 4px;
        }

        .route-stats {
            font-size: 14px;
        }
    }

    @include media-smaller('md') {
        margin-top: 99px;

        .places {
            display: block;
            margin-top: 30px;
            text-align: left;

            .points {
                .point {
                    display: none;
                }

                .icon {
                    margin: 20px 0;
                    top: 0;
                    left: -13px;
                    transform: rotate(90deg);
                }
            }

            .left,
            .right {
                text-align: inherit;
            }

                .place {
                    line-height: 0.91;

                    span {
                        font-size: 1em !important; // to cancel out JS font-size
                    }
                }
        }

        .places-separator {
            border-left: none;
            border-right: none;

            &:after {
                content: none;
            }
        }

        .route-stats {
            margin-top: 36px;
            font-size: 15px;
            text-align: left;
        }
    }
} // #route

#stats {
    margin-top: 174px;

    .illustration {
        margin-bottom: 68px;
        height: 200px;
        text-align: left;

        svg {
            max-width: 100%;
            height: 100%;
            fill: none;
            stroke: $color-illustrations;
        }
    }

    .items {
        display: flex;
        flex-flow: row wrap;
    }

        .result-stat {
            width: 50%;
            margin-bottom: 60px;
        }

            .is-draggable {
                position: relative;
                cursor: pointer;
                cursor: ns-resize;
                user-select: none;

                &:hover,
                &.is-dragging {
                    .icon-slider svg {
                        animation-play-state: running;
                    }
                }
            }

                .icon-slider {
                    display: flex;
                    padding: 20px;
                    position: absolute;
                        top: 2em;
                        left: -20px;

                    color: $color-text-accent-1-darker;
                    transform: translate(-50%, -50%);

                    svg {
                        font-size: 42px;
                        animation: slider-arrow-shake-vertical 0.6s $easing-easeInOutCubic infinite;
                        animation-delay: -0.3s; // to make the animation start from 50%, which is neutral
                        animation-play-state: paused;
                        animation-direction: alternate;
                        animation-fill-mode: none;
                    }

                    svg.fa-arrows-h {
                        animation-name: slider-arrow-shake-horizontal;
                    }
                }

    @include media-smaller('md') {
        margin-top: 120px;

        .illustration {
            height: auto;
            margin-bottom: 40px;
        }

        .items {
            display: block;
        }

            .result-stat {
                width: 100%;
                margin-bottom: 40px;
            }

                .is-draggable {
                    cursor: ew-resize;
                }

                    .icon-slider {
                        margin: -20px;
                        position: static;
                        transform: none;

                        svg {
                            font-size: 45px;
                        }
                    }
    }
} // #stats

#alternatives {
    margin-top: $grid-size * 4;

    .heading-alternatives {
        position: relative;
        margin-bottom: 92px;

        font-size: 16px;
        text-align: left;

        small {
            position: absolute;
                left: 18.14em;

            font-size: 1em;
            font-weight: normal;
            line-height: 1.24;
            text-align: left;
            color: $color-text-2;

            &.top {
                bottom: 100%;
                margin-bottom: -2em;
            }

            &.bottom {
                top: 100%;
            }
        }

        .large {
            display: block;
            margin-top: -0.25em;
            font-family: $font-family-2;
            font-size: 8em;
            font-weight: $font-weight-2-light;
            line-height: 1;
            color: $color-white;
        }
    }

    .alternatives {
        display: flex;
        flex-flow: row wrap;
        margin: -($grid-size / 2);

        .alternative-transport {
            width: 50%;
            padding: ($grid-size / 2);
        }
    }

    @include media-smaller('lg') {
        .heading-alternatives {
            font-size: 14px;
        }
    }

    @include media-smaller('md') {
        .heading-alternatives {
            margin-bottom: $grid-size * 2;
            font-size: 12px;

            small {
                left: 9.1em;

                &.top {
                    margin-bottom: -1em;
                }
            }

            .large {
                font-size: 4em;
            }
        }

        .alternatives {
            display: block;

            .alternative-transport {
                width: 100%;
            }
        }
    }
}

#info {
    margin-top: 60px;
    margin-bottom: 240px;

    .heading {
        font-family: $font-family-2;
        font-size: 64px;
        text-align: left;
        color: $color-text-2;

        .large {
            font-size: 1.54em;
            line-height: 1;
            color: $color-white;
        }

        .separator {
            margin-left: 0.55em;
        }

        .main {
            display: block;
            max-width: 7em;
            margin-top: 0.1em;

            line-height: 0.97;
        }
    } // .heading

    .facts {
        display: flex;
        flex-flow: row wrap;

        .stat-fact {
            width: 50%;
        }
    }

    .text-slider {
        margin-top: 51px;
    }

    @include media-smaller('md') {
        margin-top: $grid-size * 2;

        .heading {
            margin-bottom: $grid-size * 2;
            font-size: 34px;
        }

        .facts {
            display: block;

            .stat-fact {
                width: 100%;
                margin-bottom: $grid-size;
            }
        }
    }
} // #info
</style>

<template>
    <div>
        <h1 class="results-heading">
            <span class="emissions-count">
                {{ formatUnit(_convert(baseTravelMode.emissions.total, 'g')) }}
            </span>
            <div class="bottom">
                <div class="left">
                    <span title="Carbon dioxide">CO<sub>2</sub></span>
                    <span class="separator">/</span>
                    <span class="subject">
                        This <br> Route
                        <UnitSwitch
                            :active="$store.state.measurementSystem"
                            @change="$store.commit('setMeasurementSystem', $event)"
                        ></UnitSwitch>
                    </span>
                </div>
                <div v-if="baseTravelMode.emissions.nox > 0" class="right">
                    <span>
                        {{ formatUnit(_convert(baseTravelMode.emissions.nox, 'g')) }}
                    </span>
                    <span class="element" title="Nitrogen oxide">NO<sub>X</sub></span>
                </div>
            </div>
        </h1>

        <section id="route">
            <h2 class="subtitle">Your Route</h2>

            <div class="places">
                <div class="left">
                    <p class="place">
                        <span :style="{
                            'font-size': routeFontSize + 'em'
                        }">
                            {{ routeTitles.origin }}
                        </span>
                    </p>
                    <p class="description">{{ journey.originText.secondary }}</p>
                </div>

                <div class="points">
                    <span class="point">A.</span>
                    <span class="icon">
                        <fa :icon="['fal', 'long-arrow-right']"></fa>
                    </span>
                    <span class="point">B.</span>
                </div>

                <div class="right">
                    <p class="place">
                        <span :style="{
                            'font-size': routeFontSize + 'em'
                        }">
                            {{ routeTitles.destination }}
                        </span>
                    </p>
                    <p class="description">{{ journey.destinationText.secondary }}</p>
                </div>
            </div>

            <div class="places-separator"></div>

            <div class="route-stats">
                <p class="distance">
                    {{ formatNumber(_convert(journey.distance, 'm').value) }}<i>{{ _convert().unit.abbr }}</i>
                </p>
                <p class="time">
                    {{ formatTime(journey.duration * 1000) }} drive
                </p>
            </div>
        </section>

        <section id="stats">
            <div class="illustration">
                <component :is="vehicle.image"></component>
            </div>

            <div class="items">
                <ResultStat title="Vehicle Type">
                    <template slot="content">
                        <p>{{ vehicle.title }}</p>
                        <small>
                            Example vehicles: {{ vehicle.examples.join(', ') }}
                        </small>
                    </template>
                </ResultStat>

                <ResultStat title="Fuel Consumption">
                    <div
                        title="Click and drag up and down to adjust the fuel consumption value."
                        slot="content"
                        v-dragged="onConsumptionDrag"
                        :class="{
                            'is-draggable': true,
                            'is-dragging': isDragging
                        }"
                    >
                        <p v-if="fuelMeta.emissionsLitre">
                            <template v-if="displayConsumption.unit.abbr === 'mpg'">
                                {{ formatNumber(displayConsumption.value) + displayConsumption.unit.abbr.toUpperCase() }}
                            </template>
                            <template v-else>
                                {{ formatNumber(displayConsumption.value) }}L<span class="separator">/</span>100<i>km</i>
                            </template>
                        </p>
                        <p v-else-if="fuelMeta.emissionsKwh">
                            {{
                                formatNumber(displayConsumption.value) + 'kWh'
                            }}<span class="separator">/</span>100<i>{{ displayConsumption.unit.abbr }}</i>
                        </p>

                        <small>
                            This is how much a {{ vehicle.title.toLowerCase() }} type of vehicle typically consumes. Use the slider to adjust the value.
                        </small>
                        <div class="icon-slider">
                            <fa v-if="$store.getters.viewport > 1" :icon="['fal', 'arrows-v']"></fa>
                            <fa v-else :icon="['fal', 'arrows-h']"></fa>
                        </div>
                    </div>
                </ResultStat>

                <ResultStat title="Fuel Type">
                    <p slot="content">
                        {{ fuel.title }}
                    </p>
                </ResultStat>

                <ResultStat title="CO2 Emissions">
                    <div slot="content">
                        <p>
                            {{ formatNumber(_convert(baseTravelMode.emissions.kilometer, ['g', 'km']).value) + _convert().unit[0].abbr }}<span class="separator">/</span><i>{{ _convert().unit[1].abbr }}</i>
                        </p>
                        <small
                            v-if="fuel.emissionsText"
                            v-html="fuel.emissionsText"
                        ></small>
                    </div>
                </ResultStat>
            </div><!-- .stats -->
        </section>

        <section v-if="$store.getters.alternatives.length" id="alternatives">
            <h2 class="heading-alternatives">
                <small class="top">What<br>are<br>the</small>
                <span class="large">Alternatives</span>
                <small class="bottom">?</small>
            </h2>

            <div class="alternatives">
                <AlternativeTransport
                    v-for="(alternative, index) in $store.getters.alternatives"
                    :key="index"
                    :data="alternative"
                ></AlternativeTransport>
            </div>
        </section>

        <section id="info">
            <h2 class="heading">
                <span class="large">So</span><span class="separator">/</span>
                <span class="main">What does this mean?</span>
            </h2>

            <div class="facts">
                <StatFact :icon="['fas', 'tree-alt']" title="Nature">
                    <template slot="value">{{ formatTime(absorbTime) }}</template>
                    <template slot="description">
                        would be the time needed for a tree to absorb the amount of emitted <abbr title="Carbon dioxide">CO<sub>2</sub></abbr> during your trip to {{ journey.destinationText.main }}.
                    </template>
                </StatFact>

                <StatFact v-if="dailyRouteEmissions" :icon="['fas', 'briefcase']" title="Annual Emissions">
                    <template slot="value">{{ formatUnit(_convert(dailyRouteEmissions.yearly, 'g')) }}</template>
                    <template slot="description">
                        would be the approximate amount of <abbr title="Carbon dioxide">CO<sub>2</sub></abbr> you generate for one year if this is your daily route to work. This equals to about {{ formatUnit(_convert(dailyRouteEmissions.monthly, 'g')) }} per month.
                    </template>
                </StatFact>

                <StatFact v-if="baseTravelMode.emissions.no2 > 0" :icon="['fas', 'heartbeat']" title="Health">
                    <template slot="value">{{ formatUnit(_convert(baseTravelMode.emissions.no2, 'g')) }}</template>
                    <template slot="description">
                        would be the resulting <abbr title="Nitrogen dioxide">NO<sub>2</sub></abbr> after the emitted {{ formatUnit(_convert(baseTravelMode.emissions.nox, 'g')) }} <abbr title="Nitrogen oxide">NO<sub>X</sub></abbr> combine with the oxygen in the air. Both of these gasses are toxic and can cause respiratory problems or lung damage. This has an even bigger impact on people with asthma or heart disease.
                    </template>
                </StatFact>
            </div>

            <TextSlider :items="presets('facts')"></TextSlider>
        </section>
    </div>
</template>

<script>
import {
    FUELS,
    DAILY_ROUTE_DISTANCE
} from '@/const';

import dragged from 'v-dragged';
import emissions from '@/utils/emissions';
import formatter from '../mixins/formatter';

import UnitSwitch from '@/components/entities/UnitsSwitch';
import ResultStat from '../components/entities/ResultStat';
import AlternativeTransport from '../components/entities/AlternativeTransport';
import StatFact from '../components/entities/StatFact';
import TextSlider from '../components/entities/TextSlider';

var _customConsumption = false;

export default {
    components: {
        UnitSwitch,
        ResultStat,
        AlternativeTransport,
        StatFact,
        TextSlider
    },
    mixins: [
        formatter
    ],
    directives: {
        dragged: dragged.directive
    },
    data () {
        return {
            isDragging: false
        };
    },
    computed: {
        journey () {
            return this.$store.getters.journey;
        },
        baseTravelMode () {
            return this.$store.getters.baseTravelMode;
        },
        vehicle () {
            return this.presets('vehicles')[this.journey.vehicle];
        },
        fuel () {
            return this.presets('fuels')[this.journey.fuel];
        },
        fuelMeta () {
            return FUELS[this.journey.fuel] || {};
        },
        routeTitles () {
            return {
                origin: this.journey.originText.main || 'Unknown',
                destination: this.journey.destinationText.main || 'Unknown'
            };
        },
        routeFontSize () {
            var maxCharacters = Math.max(
                this.routeTitles.origin.length,
                this.routeTitles.destination.length
            );

            return Math.min(8 / maxCharacters, 1);
        },
        displayConsumption () {
            var unit = this.fuelMeta.emissionsLitre ? 'l/100km' : 'km';
            return this._convert(this.journey.consumption, unit);
        },
        dailyRouteEmissions () {
            if (this.baseTravelMode.distance < DAILY_ROUTE_DISTANCE) {
                return emissions.dailyRouteEmissions(this.baseTravelMode.emissions.total);
            }
        },
        absorbTime () {
            return emissions.timeToAbsorb(this.baseTravelMode.emissions.total);
        }
    },
    methods: {
        onConsumptionDrag (data) {
            var delta = null,
                absDeltaX = Math.abs(data.deltaX),
                absDeltaY = Math.abs(data.deltaY);

            if (this.$store.getters.viewport > 1) {
                if (absDeltaY > absDeltaX) {
                    delta = -data.deltaY;
                }
            } else if (absDeltaX > absDeltaY) {
                delta = data.deltaX;
            }

            if (delta) {
                this.$store.dispatch('incrementConsumption', {
                    unit: this.displayConsumption.unit.abbr,
                    delta: delta * 0.1
                });
            }

            if (data.first) {
                this.isDragging = true;
            } else if (data.last) {
                this.isDragging = false;

                if (!_customConsumption) {
                    _customConsumption = true;

                    gtag('event', 'input', {
                        'event_label': 'Changed consumption',
                        'event_category': 'journey'
                    });
                }
            }
        }
    }
};
</script>
